import { useSelector } from 'react-redux';
import { selectCurrentRoles } from '../features/auth/authSlice';
import { selectEffectiveRoles, selectIsPreviewActive } from '../features/rolePreview/rolePreviewSlice';
import { ROLES_LIST } from '../features/roles/roles.config';

const useAuth = () => {
  const realRoles = useSelector(selectCurrentRoles);
  const roles = useSelector(selectEffectiveRoles);
  const isPreviewActive = useSelector(selectIsPreviewActive);

  let isEditor = false;
  let isAdmin = false;
  let isUser = false;
  let isSuperAdmin = false;
  let isMember = false;
  let status = 'User';

  // Real role flags — always based on actual JWT roles, never affected by preview
  const isRealAdmin = Array.isArray(realRoles) && realRoles.includes(ROLES_LIST.Admin);
  const isRealSuperAdmin = Array.isArray(realRoles) && realRoles.includes(ROLES_LIST.SuperAdmin);

  const { User, Editor, Admin, SuperAdmin, Mitglied } = ROLES_LIST;

  if (roles) {
    isUser = roles.includes(User);
    isEditor = roles.includes(Editor);
    isAdmin = roles.includes(Admin);
    isSuperAdmin = roles.includes(SuperAdmin);
    isMember = roles.includes(Mitglied);

    if (isMember) status = 'Mitglied';
    if (isUser) status = 'User';
    if (isEditor) status = 'Editor';
    if (isAdmin) status = 'Admin';
    if (isSuperAdmin) status = 'SuperAdmin';

    return {
      roles,
      status,
      isUser,
      isEditor,
      isAdmin,
      isSuperAdmin,
      isMember,
      isRealAdmin,
      isRealSuperAdmin,
      isPreviewActive,
    };
  }

  return {
    roles: [],
    isUser,
    isEditor,
    isAdmin,
    isSuperAdmin,
    isMember,
    isRealAdmin,
    isRealSuperAdmin,
    isPreviewActive,
    status,
  };
};
export default useAuth;
